import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class LoaderService {
  loadingEvents : any[] = [];

  constructor(public baseService: BaseService) { }

  addGreyLoaderClass() {
    (<any>window).domBody.classList.add('show-loading-grey');
  }

  removeGreyLoaderClass() {
    (<any>window).domBody.classList.remove('show-loading-grey');
  }

  addWhiteLoaderClass() {
    (<any>window).domBody.classList.add('show-loading-white');
  }

  removeWhiteLoaderClass() {
    (<any>window).domBody.classList.remove('show-loading-white');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loader.service.ts